import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

const usePageBuilderStore = create(
  immer((set) => ({
    // UI State
    viewMode: 'draft',
    selectedBlockId: null,
    isViewModeChanging: false,
    isLocaleChanging: false,

    // Draft State
    draftStates: {},
    localBlocks: [],
    hasUnsavedChanges: false,
    hasDraftStates: false,

    // Actions
    setViewMode: (mode) =>
      set((state) => {
        state.viewMode = mode
      }),

    setSelectedBlockId: (id) =>
      set((state) => {
        state.selectedBlockId = id
      }),

    setIsViewModeChanging: (value) =>
      set((state) => {
        state.isViewModeChanging = value
      }),

    setIsLocaleChanging: (value) =>
      set((state) => {
        state.isLocaleChanging = value
      }),

    updateDraftField: (blockId, fieldId, value) =>
      set((state) => {
        if (!state.draftStates[blockId]) {
          state.draftStates[blockId] = {}
        }
        state.draftStates[blockId][fieldId] = value
      }),

    setDraftStates: (states) =>
      set((state) => {
        state.draftStates = states
      }),

    clearDraftStates: () =>
      set((state) => {
        state.draftStates = {}
      }),

    addLocalBlock: (block) =>
      set((state) => {
        state.localBlocks.push(block)
        state.hasUnsavedChanges = true
      }),

    removeLocalBlock: (blockId) =>
      set((state) => {
        state.localBlocks = state.localBlocks.filter((b) => b.id !== blockId)
      }),

    clearLocalBlocks: () =>
      set((state) => {
        state.localBlocks = []
      }),

    setHasUnsavedChanges: (value) =>
      set((state) => {
        state.hasUnsavedChanges = value
      }),

    setHasDraftStates: (value) =>
      set((state) => {
        state.hasDraftStates = value
      }),
  }))
)

export default usePageBuilderStore
